import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Idea: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_30882)'>
        <path
          d='M14.5137 17.3952V20.2178C14.5137 21.7263 13.2908 22.9492 11.7822 22.9492C10.2737 22.9492 9.05078 21.7263 9.05078 20.2178V17.3952'
          stroke='url(#paint0_linear_12280_30882)'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path
          d='M11.7818 1.00185C8.31759 1.00185 5.59332 3.52563 5.05795 6.62065C4.64222 9.02411 5.49471 11.2485 7.05347 12.7445C8.32014 13.9602 9.05031 15.6339 9.05031 17.3896L14.5132 17.3906C14.5132 15.6349 15.2434 13.9602 16.5101 12.7445C18.0689 11.2485 18.9213 9.02411 18.5056 6.62065C17.9731 3.54215 15.2673 1.00185 11.7818 1.00185Z'
          stroke='url(#paint1_linear_12280_30882)'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='square'
        />
        <path
          d='M11.6877 10.4452C11.4394 10.4452 11.2383 10.2415 11.2383 9.99056V9.64043C11.2383 8.97968 11.6091 8.37858 12.2305 8.0328C12.6734 7.78475 12.8948 7.2741 12.7817 6.76223C12.6899 6.35705 12.3582 6.02122 11.9563 5.92835C11.6378 5.85415 11.3179 5.91429 11.0564 6.0959C10.7966 6.27655 10.6224 6.55976 10.578 6.87255C10.5426 7.12085 10.3204 7.29471 10.069 7.25785C9.82361 7.2222 9.65297 6.99161 9.6882 6.74331C9.76849 6.17955 10.0815 5.67035 10.5474 5.34665C11.0183 5.01955 11.5908 4.91237 12.1562 5.04161C12.8991 5.21353 13.4889 5.81002 13.6584 6.56146C13.8606 7.47244 13.4614 8.38294 12.6652 8.82886C12.3343 9.01314 12.1373 9.31623 12.1373 9.64043V9.99056C12.1373 10.2415 11.9359 10.4452 11.6877 10.4452Z'
          fill='url(#paint2_linear_12280_30882)'
          stroke='url(#paint3_linear_12280_30882)'
          strokeWidth='0.8'
        />
        <path
          d='M11.6915 12.2687C11.9397 12.2687 12.1409 12.0651 12.1409 11.814C12.1409 11.5629 11.9397 11.3594 11.6915 11.3594C11.4434 11.3594 11.2422 11.5629 11.2422 11.814C11.2422 12.0651 11.4434 12.2687 11.6915 12.2687Z'
          fill='url(#paint4_linear_12280_30882)'
          stroke='url(#paint5_linear_12280_30882)'
          strokeWidth='0.8'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_30882'
          x1='10.182'
          y1='22.5705'
          x2='12.7381'
          y2='17.5314'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30882'
          x1='7.78124'
          y1='16.2731'
          x2='16.0208'
          y2='2.51108'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_30882'
          x1='10.5175'
          y1='5.36038'
          x2='13.4059'
          y2='9.63235'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_30882'
          x1='10.5175'
          y1='5.36038'
          x2='13.4059'
          y2='9.63235'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_30882'
          x1='11.4283'
          y1='11.4214'
          x2='11.8456'
          y2='12.248'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_30882'
          x1='11.4283'
          y1='11.4214'
          x2='11.8456'
          y2='12.248'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_30882'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Idea;
